const configDefault = {};
configDefault.SPIService = 'https://birdexp07.knmi.nl:8443//adaguc-services/adagucserver?dataset=Irene&&service=WMS&';
configDefault.L13Service = 'https://birdexp07.knmi.nl:8443//adaguc-services//adagucserver?dataset=L13&&service=WMS&';
configDefault.baselayerService = 'https://adaguc-server-spi-monitor-dev-dev-25gqse.pub.dev.knmi.cloud/adagucserver?dataset=spibaselayers&';
module.exports = configDefault;
